import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';

import Modal from '../modal';

type Props = {
  redirectedFromMarket: string;
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  padding: 16px 0;
`;

// Since shutting down PriceSpy.ie, we are redirecing all that traffic to PriceSpy.co.uk
// and we want to show a notification for that traffic as to why they have been redirected.
const ShutdownMessageModal = (props: Props) => {
  const { redirectedFromMarket } = props;
  const { t } = useContext(AppContext);
  const [isVisible, setVisibility] = useState(true);

  if (!IS_BROWSER || !isVisible) return null;

  const rootElement = document.getElementById('root-modal');

  const closeModal = () => {
    setVisibility(false);
  };

  const message = t(
    'common',
    // @ts-ignore
    `shutdown.redirect-message-${redirectedFromMarket}`
  );

  return rootElement
    ? createPortal(
        <Modal width={500} isOpen onRequestClose={closeModal}>
          <Content>
            {message}
            <div>
              <Button
                style={{ marginTop: '16px' }}
                color="primary"
                onClick={closeModal}
              >
                Okay
              </Button>
            </div>
          </Content>
        </Modal>,
        rootElement
      )
    : null;
};

export default ShutdownMessageModal;
